(function () {
  'use strict';
  const config = document.querySelector('[data-zs-search-config]');
  if (!config || config.dataset.ready) return;
  config.dataset.ready = 'true';
  const text = config.dataset;
  const closeAll = [];
  const mobile = window.matchMedia('(max-width: 767px)');
  let nextId = 0;

  async function loadCategories() {
    const page = document.querySelector('[data-zs-search-query]');
    const region = document.querySelector('[data-zs-search-categories]');
    const guides = document.querySelector('[data-zs-search-guides]');
    const query = page ? page.dataset.zsSearchQuery.trim() : '';
    if ((!region && !guides) || query.length < 2) return;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 6000);
    try {
      const url = new URL(text.endpoint, location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'collection,article');
      url.searchParams.set('resources[limit]', '10');
      url.searchParams.set('resources[limit_scope]', 'each');
      url.searchParams.set('section_id', 'zs-predictive-search');
      const response = await fetch(url, {signal: controller.signal, credentials: 'same-origin'});
      if (!response.ok) return;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const links = doc.querySelector('[data-zs-category-results]');
      if (region && links && links.querySelector('a')) {
        region.querySelector('[data-zs-category-links]').replaceChildren(links);
        region.hidden = false;
      }
      const guide = doc.querySelector('[data-zs-guides-link]');
      if (guides && guide) {
        guides.replaceChildren(guide);
        guides.hidden = false;
      }
    } catch (error) {
      // Product results and native filters remain available if suggestions fail.
    } finally {
      clearTimeout(timeout);
    }
  }

  function attach(form) {
    const input = form.querySelector('input[name="q"]');
    if (!input || input.dataset.zsSuggest) return;
    input.dataset.zsSuggest = 'true';
    const panel = document.createElement('div');
    panel.id = 'zs-suggestions-' + (++nextId);
    panel.className = 'zs-suggest';
    panel.hidden = true;
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', text.label);
    document.body.append(panel);
    const status = document.createElement('span');
    status.className = 'zs-sr-only';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    form.append(status);
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-haspopup', 'dialog');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', panel.id);
    input.setAttribute('autocomplete', 'off');
    if (!input.getAttribute('aria-label')) input.setAttribute('aria-label', text.search);
    const submit = form.querySelector('button[type="submit"]');
    if (submit && !submit.textContent.trim() && !submit.getAttribute('aria-label')) submit.setAttribute('aria-label', text.search);
    let controller, timer, sequence = 0, composing = false;

    function position() {
      if (panel.hidden) return;
      const rect = input.getBoundingClientRect();
      const vv = window.visualViewport;
      const top = vv ? vv.offsetTop : 0;
      const left = vv ? vv.offsetLeft : 0;
      const bottom = top + (vv ? vv.height : window.innerHeight);
      const right = left + (vv ? vv.width : window.innerWidth);
      if (!rect.width || rect.bottom <= top || rect.top >= bottom) { close(); return; }
      const width = Math.min(Math.max(rect.width, 300), right - left - 24);
      panel.style.width = width + 'px';
      panel.style.left = Math.max(left + 12, Math.min(rect.left, right - width - 12)) + 'px';
      panel.style.top = Math.min(rect.bottom + 6, bottom - 100) + 'px';
      panel.style.maxHeight = Math.max(80, bottom - rect.bottom - 18) + 'px';
    }
    function close() {
      clearTimeout(timer);
      sequence++;
      if (controller) controller.abort();
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-busy');
      status.textContent = '';
    }
    closeAll.push(close);
    function show(content) {
      panel.replaceChildren(content);
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      position();
    }
    async function request(query, version) {
      const localController = new AbortController();
      controller = localController;
      const timeout = setTimeout(() => localController.abort(), 6000);
      input.setAttribute('aria-busy', 'true');
      status.textContent = text.loading;
      try {
        const url = new URL(text.endpoint, location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product,collection,article');
        url.searchParams.set('resources[limit]', '6');
        url.searchParams.set('resources[limit_scope]', 'each');
        url.searchParams.set('resources[options][unavailable_products]', 'last');
        url.searchParams.set('section_id', 'zs-predictive-search');
        const response = await fetch(url, {signal: localController.signal, credentials: 'same-origin'});
        if (!response.ok) throw new Error('Search unavailable');
        const html = await response.text();
        if (version !== sequence || document.activeElement !== input || input.value.trim() !== query) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const results = doc.querySelector('[data-zs-predictive-results]');
        if (!results) throw new Error('Missing search results');
        results.querySelectorAll('[data-zs-category-results] > li:nth-child(n+4)').forEach(item => item.remove());
        show(results);
        status.textContent = text.label;
      } catch (error) {
        if (version !== sequence || document.activeElement !== input) return;
        const message = document.createElement('p');
        message.className = 'zs-suggest__message';
        message.textContent = text.failed;
        show(message);
        status.textContent = text.failed;
      } finally {
        clearTimeout(timeout);
        if (version === sequence) input.removeAttribute('aria-busy');
      }
    }
    function schedule() {
      close();
      if (composing || mobile.matches) return;
      const query = input.value.trim();
      if (query.length < 2) return;
      const version = sequence;
      timer = setTimeout(() => request(query, version), 200);
    }
    input.addEventListener('compositionstart', () => { composing = true; close(); });
    input.addEventListener('compositionend', () => { composing = false; schedule(); });
    input.addEventListener('input', schedule);
    input.addEventListener('focus', () => { closeAll.forEach(fn => fn()); schedule(); });
    input.addEventListener('keydown', event => {
      if (event.isComposing) return;
      if (event.key === 'Escape') { close(); event.stopPropagation(); }
      if (event.key === 'ArrowDown' && !panel.hidden) {
        const link = panel.querySelector('a');
        if (link) { event.preventDefault(); link.focus(); }
      }
    });
    panel.addEventListener('keydown', event => {
      const links = Array.from(panel.querySelectorAll('a'));
      const index = links.indexOf(document.activeElement);
      if (event.key === 'Escape') {
        event.preventDefault(); input.focus(); close();
      } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        const target = index + (event.key === 'ArrowDown' ? 1 : -1);
        if (target < 0) { input.focus(); } else if (links[target]) { links[target].focus(); }
      }
    });
    document.addEventListener('focusin', event => {
      if (event.target !== input && !panel.contains(event.target)) close();
    });
    document.addEventListener('pointerdown', event => {
      if (event.target !== input && !panel.contains(event.target)) close();
    });
    form.addEventListener('submit', close);
    window.addEventListener('resize', position, {passive: true});
    window.addEventListener('scroll', position, {passive: true});
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', position, {passive: true});
      window.visualViewport.addEventListener('scroll', position, {passive: true});
    }
    window.addEventListener('pageshow', close);
  }

  document.addEventListener('click', event => {
    const link = event.target.closest('.zs-search-ai a');
    const page = document.querySelector('[data-zs-search-query]');
    if (!link || !page || !document.getElementById('flyweight-chat-search')) return;
    event.preventDefault();
    window.dispatchEvent(new CustomEvent('flyweightsearch', {detail: page.dataset.zsSearchQuery}));
  });

  window.addEventListener('load', () => {
    const lupe = document.querySelector(window.matchMedia('(min-width: 1025px)').matches ? '#the-search-form-header button' : '.js-search');
    const searchPage = document.querySelector('[data-zs-search-query]');
    if (!lupe || !lupe.getClientRects().length || (searchPage && searchPage.dataset.zsSearchQuery)) return;
    let seen = false;
    try {
      seen = sessionStorage.getItem('zs-lupe-hint') === '1';
      sessionStorage.setItem('zs-lupe-hint', '1');
    } catch (error) {}
    if (!seen) lupe.classList.add('zs-lupe-hint');
  });

  document.querySelectorAll('#the-search-form-header, #the-search-form, .zsm-search, [data-zs-search-form]').forEach(attach);
  loadCategories();
  if (window.matchMedia('(max-width: 767px)').matches) {
    document.querySelectorAll('.zs-search-facets').forEach(details => { details.open = false; });
  }
})();
